<template>
  <div>
    <Menu />
    <div class="container main">
      <div class="row">
        <div class="col-md-12">
          <SectionTitle
            title="Oficinas Reuniões Treinamentos"
            description="Gerencie oficinas, reuniões e treinamentos"
            url="/dashboard"
          />
        </div>
      </div>
      <div class="grid-itens">
        <div v-for="(item, index) in cards" :key="index" class="item-flex">
          <router-link :to="item.link">
            <div class="item">
              <i v-if="item.icone !== false" :class="item.icone"></i>
              <img
                v-else-if="item.imagem !== ''"
                :src="item.imagem !== '' ? item.imagem : ''"
                alt=""
              />
              <component v-else :is="item.svg" />
              <h3>
                {{ item.titulo }}
              </h3>
            </div>
          </router-link>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import Menu from '@/components/Menu'
import Footer from '@/components/Footer'
import SectionTitle from '@/components/SectionTitle'

export default {
  name: 'OficinasTreinamentos',
  metaInfo: {
    title: 'Oficinas Reuniões Treinamentos',
    titleTemplate: null,
  },
  components: {
    Menu,
    Footer,
    SectionTitle,
  },
  computed: {
    cards() {
      if (
        this.$store.state &&
        this.$store.state.permissoes &&
        this.$store.state.permissoes.oficinas_treinamentos
      ) {
        return this.$store.state.permissoes.oficinas_treinamentos
          .filter(item => item?.key !== 'ficha_atividade_coletiva'  && item?.key !== 'oficinas_treinamentos_guia_apresentacao'  && item?.key !== 'oficinas_treinamentos_guia')
          .sort((a, b) => a.ordem - b.ordem)
      }

      return []
    }
  },
  data() {
    return {}
  },
}
</script>

<style></style>
